const template = `
<label class="checkbox"><input type="checkbox" value="%race-number%" name="%name%"><span></span>%race-number%</label>
`;

export default template;
